<!-- src/components/AuthInfoDrawer.vue -->
<template>
  <a-drawer
    :title="drawerTitle"
    :visible="visible"
    width="70%"
    @close="handleClose"
  >
    <div class="auth-info-drawer">
      <!-- 手机号输入 -->
      <a-form-item label="手机号" :required="true" style="margin-bottom: 24px;">
        <a-input
          :value="fileData.phoneNumber"
          placeholder="请输入手机号"
          :disabled="true"
          style="width: 100%;"
        />
      </a-form-item>

      <!-- 动作组合上传列表 -->
      <div class="upload-list">
        <div
          v-for="(action, index) in actionCombinations"
          :key="index"
          class="upload-item"
        >
          <h4 class="action-title">{{ action.label }}</h4>
          <VideoUploadItem
            :action-key="action.key"
            :phone-number="fileData.phoneNumber"
            :fileNameList="fileData.fileNameList"
            @upload-success="handleUploadSuccess"
            @upload-error="handleUploadError"
          />
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
/**
 * 辅助认证信息抽屉组件
 * 包含12个动作组合的视频上传组件
 */
import { Drawer, Form, Input } from 'ant-design-vue'
import VideoUploadItem from './VideoUploadItem.vue'

export default {
  name: 'AuthInfoDrawer',
  components: {
    'a-drawer': Drawer,
    'a-form-item': Form.Item,
    'a-input': Input,
    VideoUploadItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    drawerTitle: {
      type: String,
      default: '添加辅助认证信息'
    }
  },
  data() {
    return {
      // 12个动作组合：4个动作的两两排列组合（有顺序）
      // nod（点头）、shake（摇头）、blink（眨眼）、openMouth（张嘴）
      actionCombinations: [
        { key: 'nod_shake', label: '点头-摇头' },
        { key: 'nod_openMouth', label: '点头-张嘴' },
        { key: 'nod_blink', label: '点头-眨眼' },
        { key: 'shake_nod', label: '摇头-点头' },
        { key: 'shake_openMouth', label: '摇头-张嘴' },
        { key: 'shake_blink', label: '摇头-眨眼' },
        { key: 'openMouth_nod', label: '张嘴-点头' },
        { key: 'openMouth_shake', label: '张嘴-摇头' },
        { key: 'openMouth_blink', label: '张嘴-眨眼' },
        { key: 'blink_nod', label: '眨眼-点头' },
        { key: 'blink_shake', label: '眨眼-摇头' },
        { key: 'blink_openMouth', label: '眨眼-张嘴' }
      ],
      fileData: {
        phoneNumber: '',
        fileNameList: []
      }
    }
  },
  mounted() {

  },
  methods: {
    /**
     * 关闭抽屉
     */
    handleClose() {
      this.$emit('close')
    },
    /**
     * 上传成功回调
     * @param {string} actionKey - 动作组合的 key
     * @param {object} data - 上传返回的数据
     * @param {string} fileName - 上传的文件名
     */
    handleUploadSuccess(actionKey, data, fileName) {
      // 如果 fileNameList 中还没有这个文件名，则添加
      if (fileName && !this.fileData.fileNameList.includes(fileName)) {
        this.fileData.fileNameList.push(fileName)
      }
      this.$emit('upload-success', actionKey, data)
    },
    /**
     * 上传失败回调
     */
    handleUploadError(actionKey, error) {
      this.$emit('upload-error', actionKey, error)
    }
  }
}
</script>

<style scoped>
.auth-info-drawer {
  padding: 0;
}

.upload-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.upload-item {
  padding: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
}

.action-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
</style>

